module.exports = __webpack_public_path__ + "img/title-one.796bb848.png";